// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xfrp","field":"styles_field__1CBlw","fieldCol":"styles_fieldCol__10oJ5","diffCol":"styles_diffCol__18jXR","diff":"styles_diff__1x0zX"};